// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__MDq0T","content":"Preloader_content__TmfBQ"};